module.exports = __webpack_public_path__ + "img/Carta Mundi.308d60d8.jpg";